import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type UpdateAccountMainDetailsMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateAccountMainDetailsInput;
}>;

export type UpdateAccountMainDetailsMutationResult = { __typename?: 'Mutation' } & {
  updateAccountMainDetails?: GraphQLTypes.Maybe<
    { __typename?: 'UpdateAccountMainDetailsPayload' } & Pick<GraphQLTypes.UpdateAccountMainDetailsPayload, 'accountId'> & {
        errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
      }
  >;
};

export const UpdateAccountMainDetailsDocument = gql`
  mutation UpdateAccountMainDetails($input: UpdateAccountMainDetailsInput!) {
    updateAccountMainDetails(input: $input) {
      accountId
      errors {
        message
        path
      }
    }
  }
`;
